export const gameControllers = {
  lastAnimationFrameTime: 1,
};

export const gameConstants = {
  COLLISION_MARGIN: 5,
  ENTRANCE_COLLISION_THRESHOLD: 2,
  INITIAL_X: 50,
  INITIAL_Y: 50,
  TIME_DIFFERENCE_BETWEEN_UPDATES: 16,
};
